import React, { FC } from "react"
import { colors } from "../../utils/theme"
import GrowthIcon from "../atoms/GrowthIcon"
import NorthStarIcon from "../atoms/NorthStarIcon"
import EnjoymentIcon from "../atoms/EnjoymentIcon"

interface CustomLabelProps {
  x: number
  y: number
  datum: { fill: string }
}

const MoodBarIconLabel: FC<CustomLabelProps> = ({ x, y, datum }) => {
  const positionX = x - 11
  const positionY = y - 40
  return (
    <g>
      {datum.fill === colors.primary.periwinkle ? (
        <GrowthIcon x={positionX} y={positionY} />
      ) : datum.fill === colors.tertiary.violet ? (
        <NorthStarIcon x={positionX} y={positionY} />
      ) : datum.fill === colors.tertiary.orange ? (
        <EnjoymentIcon x={positionX} y={positionY} />
      ) : null}
    </g>
  )
}

export default MoodBarIconLabel
